import client from "../server/Client";
import {useQuery} from "@tanstack/react-query";

const forms = (categoryId) => client.get(`forms/types/${categoryId}`);
export const useCategoryForms = (categoryId) => useQuery(['categoryForms', categoryId],
    () => forms(categoryId),
    {select: data => data?.data?.result})